import {Card, CardContent, Grid} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import React, {useState} from "react";
import {NotificationBox, notifications} from '../elements/notificationBox'
import {MapStateToProps, connect} from "react-redux";
import Hidden from "@material-ui/core/Hidden";

interface OwnProps {
}

interface ConnectStateProps {
    Case?: any,
}

const elem1 = () => {
    return [95, 152, 152].map((val, key) => {
        return (
            <p className="mb-1" key={key}>
                <Skeleton variant="text" width={val} height={22}/>
            </p>
        )
    })
};

/*const elem2 = () => {
    return [54, 398, 398, 398].map((val, key) => {
        return (
            <p className="mb-1" key={key}>
                <Skeleton variant="text" width={val}/>
            </p>
        )
    })
};*/


const EmptyLawyers = (props: any) => {
    const {CaseStatusNotifications} = notifications,
        {Case} = props,
        [caseData] = useState(Case.caseData || Case);

    return (
        <Card className="card-lawyers-loader  mb-4" variant="outlined">
            <CardContent className="p-3 d-flex">
                <Grid container>
                    <Grid item xs={4} lg={1}>
                        <div>
                            <Skeleton variant="circle" height={62} width={62}/>
                        </div>
                    </Grid>
                    <Grid item xs={8} lg={3}>
                        <div>
                            {elem1()}
                        </div>
                    </Grid>
                    {<Grid item xs={12} lg={7} className="mt-2 mt-md-0">
                        <Hidden xsDown>
                            <NotificationBox
                                severity={CaseStatusNotifications[caseData.status].severity}
                                text={CaseStatusNotifications[caseData.status].text}/>
                        </Hidden>
                    </Grid>}
                </Grid>
            </CardContent>
        </Card>
    )
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {Case} = state;
    return {
        Case
    }
};

export default connect(mapStateToProps)(EmptyLawyers);
